import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualPausesService, UnpauseIndividualRequest } from '@aslanpay/portal-common-lib';

const useUnpauseIndividual = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, UnpauseIndividualRequest>) => {
  return useMutation<unknown, Error, UnpauseIndividualRequest>(
    ({ id }: UnpauseIndividualRequest) => individualPausesService.unpauseIndividual({ id }),
    { onSuccess, onError }
  );
};

export default useUnpauseIndividual;
